import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import type { ViewCell } from "@lib/views";
import type { OrganizationTaskTemplateRow } from "../organizationTaskTemplatesViewConfig";

export const withKickDefaultPlaceholder = <TValue,>(
    Cell: ViewCell<OrganizationTaskTemplateRow, TValue>,
): ViewCell<OrganizationTaskTemplateRow, TValue> =>
    memo(function KickDefaultPlaceholderCell(props) {
        if (props.row.original.kickDefaultOption) {
            return (
                <ViewTableCell>
                    <span className="text-muted">-</span>
                </ViewTableCell>
            );
        }
        return <Cell {...props} />;
    });
